import { useState, type FormEvent } from "react";
import { readers } from "@/mocks/maydayContent";

export default function Readers() {
  return (
    <section id="shengming" className="scroll-mt-24 w-full bg-background-50">
      <div className="mx-auto w-full max-w-[1200px] px-4 md:px-6 py-12 md:py-16">
        <div className="text-center">
          <div className="text-xs font-medium tracking-widest text-secondary-700 mb-2">READER VOICES</div>
          <h2 className="font-heading text-3xl font-bold text-foreground-950 md:text-4xl">读者之声</h2>
          <p className="mx-auto mt-3 max-w-xl text-sm text-foreground-600 md:text-base">
            我们的读者这样说——你的避坑经验与维权故事，同样值得被看见。
          </p>
        </div>

        <div className="mt-8 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {readers.map((r) => (
            <figure
              key={r.name}
              className="flex flex-col justify-between rounded-lg bg-background-100/70 border border-background-200/70 p-5"
            >
              <div>
                <span className="mb-3 inline-flex items-center gap-1 rounded bg-secondary-100 px-2 py-0.5 text-xs font-medium text-secondary-800">
                  <i className="ri-hashtag w-3 h-3 flex items-center justify-center"></i>
                  {r.tag}
                </span>
                <blockquote className="text-sm leading-relaxed text-foreground-700">“{r.text}”</blockquote>
              </div>
              <figcaption className="mt-5 flex items-center gap-3">
                <span className="flex h-9 w-9 items-center justify-center rounded-full bg-foreground-950 text-xs font-bold text-background-50">
                  {r.name.slice(0, 1)}
                </span>
                <div>
                  <div className="text-sm font-medium text-foreground-900">
                    {r.name}
                    <span className="text-xs font-normal text-foreground-400"> · {r.city}</span>
                  </div>
                  <div className="text-xs text-foreground-500">{r.role}</div>
                </div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}